/* LOLALAN · Zen Anchor components: buy box, gallery, swipe cards, sticky add to cart. */
(function () {
  'use strict';

  var reduceMotion = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  var all = function (selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  };

  /* ---------- Buy box: pack cards, color chips, add to cart ---------- */

  if (!customElements.get('zen-buy-box')) {
    customElements.define(
      'zen-buy-box',
      class ZenBuyBox extends HTMLElement {
        connectedCallback() {
          if (this._zenReady) return;
          this._zenReady = true;

          this.sectionId = this.dataset.section;
          this.form = this.querySelector('form[data-type="add-to-cart-form"]');
          this.idInput = this.form ? this.form.querySelector('[name="id"]') : null;
          this.atc = this.querySelector('[data-zen-atc]');
          this.atcLabel = this.querySelector('[data-zen-atc-label]');
          this.priceEl = this.querySelector('[data-zen-price]');
          this.saveEl = this.querySelector('[data-zen-save]');
          this.colorLabel = this.querySelector('[data-zen-color-label]');
          this.dynamic = this.querySelector('[data-zen-dynamic]');

          this.addEventListener('change', (event) => {
            var target = event.target;
            if (target.matches('[data-zen-pack]')) this.selectPack(target, true);
            else if (target.matches('[data-zen-color]')) this.selectColor(target, true);
          });

          var initial = this.querySelector('[data-zen-pack]:checked') || this.querySelector('[data-zen-pack]');
          var params = new URLSearchParams(window.location.search);
          var wanted = parseInt(params.get('pack'), 10);
          if (wanted) {
            var match = this.querySelector('[data-zen-pack][data-count="' + wanted + '"]');
            if (match && match.dataset.available === 'true') {
              match.checked = true;
              initial = match;
            }
          }
          if (initial) this.selectPack(initial, Boolean(wanted && initial.dataset.count === String(wanted)));
        }

        selectPack(input, fromUser) {
          this.pack = input;
          all('[data-zen-pack]', this).forEach(function (packInput) {
            var card = packInput.closest('.zen-pack');
            if (card) card.classList.toggle('is-selected', packInput === input);
          });

          var index = input.value;
          var activeGroup = null;
          all('[data-zen-colors]', this).forEach(function (group) {
            var isActive = group.dataset.pack === index;
            group.hidden = !isActive;
            if (isActive) activeGroup = group;
          });

          if (this.colorLabel && input.dataset.colorLabel) this.colorLabel.textContent = input.dataset.colorLabel;

          var color = null;
          if (activeGroup) {
            color =
              activeGroup.querySelector('[data-zen-color]:checked') ||
              activeGroup.querySelector('[data-zen-color]:not([disabled])') ||
              activeGroup.querySelector('[data-zen-color]');
            if (color) color.checked = true;
          }

          this.selectColor(color, false);
          if (fromUser && input.dataset.mediaId) this.showMedia(input.dataset.mediaId);
        }

        selectColor(input, fromUser) {
          var pack = this.pack;
          if (!pack) return;

          if (input) {
            var group = input.closest('[data-zen-colors]');
            if (group) {
              all('[data-zen-color]', group).forEach(function (colorInput) {
                var chip = colorInput.closest('.zen-color');
                if (chip) chip.classList.toggle('is-selected', colorInput === input);
              });
            }
          }

          var variantId = input ? input.dataset.variantId : pack.dataset.variantId;
          var available = pack.dataset.available === 'true' && (!input || input.dataset.available === 'true');
          var label = available ? pack.dataset.atc : pack.dataset.unavailable;

          if (this.idInput && variantId) this.idInput.value = variantId;
          if (this.priceEl) {
            var useShort = this.priceEl.dataset.zenPrice === 'short';
            this.priceEl.textContent = (useShort ? pack.dataset.priceShort : pack.dataset.price) || '';
          }
          if (this.saveEl) {
            this.saveEl.textContent = pack.dataset.save || '';
            this.saveEl.hidden = !pack.dataset.save;
          }
          if (this.atcLabel && label) this.atcLabel.textContent = label;
          if (this.atc) {
            if (available) {
              this.atc.removeAttribute('disabled');
              this.atc.removeAttribute('aria-disabled');
            } else {
              this.atc.setAttribute('disabled', 'disabled');
            }
          }
          if (this.dynamic) this.dynamic.classList.toggle('is-hidden', !available);

          this.state = {
            sectionId: this.sectionId,
            variantId: variantId,
            available: available,
            price: pack.dataset.priceShort || pack.dataset.price || '',
            title: input ? input.dataset.title : '',
          };
          this.dispatchEvent(new CustomEvent('zen:variant-change', { bubbles: true, detail: this.state }));

          if (fromUser && input && input.dataset.mediaId) this.showMedia(input.dataset.mediaId);
        }

        showMedia(mediaId) {
          document.dispatchEvent(
            new CustomEvent('zen:media', { detail: { sectionId: this.sectionId, mediaId: String(mediaId) } })
          );
        }

        pickCount(count) {
          var match = this.querySelector('[data-zen-pack][data-count="' + count + '"]');
          if (!match || match.dataset.available !== 'true') return false;
          match.checked = true;
          this.selectPack(match, true);
          return true;
        }
      }
    );
  }

  /* Gift-set buttons: choose a pack in the buy box on the same page */
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-zen-pick-pack]') : null;
    if (!link) return;
    var box = document.querySelector('zen-buy-box[data-pickable]');
    if (!box || typeof box.pickCount !== 'function') return;
    if (!box.pickCount(parseInt(link.dataset.zenPickPack, 10))) return;
    event.preventDefault();
    box.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
    var selected = box.querySelector('[data-zen-pack]:checked');
    if (selected) selected.focus({ preventScroll: true });
  });

  /* ---------- Product gallery ---------- */

  if (!customElements.get('zen-gallery')) {
    customElements.define(
      'zen-gallery',
      class ZenGallery extends HTMLElement {
        connectedCallback() {
          if (this._zenReady) return;
          this._zenReady = true;

          this.track = this.querySelector('[data-zen-track]');
          if (!this.track) return;
          this.slides = all('[data-zen-slide]', this);
          this.thumbs = all('[data-zen-thumb]', this);
          this.dots = all('[data-zen-dot]', this);
          this.count = this.querySelector('[data-zen-count]');
          this.index = 0;
          this.lockUntil = 0;

          this.thumbs.forEach((button) => {
            button.addEventListener('click', () => this.go(parseInt(button.dataset.zenThumb, 10)));
          });

          var frame;
          this.track.addEventListener(
            'scroll',
            () => {
              window.cancelAnimationFrame(frame);
              frame = window.requestAnimationFrame(() => this.sync());
            },
            { passive: true }
          );

          this.track.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.go(this.index + 1);
            } else if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.go(this.index - 1);
            }
          });

          document.addEventListener('zen:media', (event) => {
            if (!event.detail || event.detail.sectionId !== this.dataset.section) return;
            var target = this.slides.findIndex((slide) => slide.dataset.mediaId === event.detail.mediaId);
            if (target > -1) this.go(target);
          });
        }

        go(index) {
          if (!this.slides.length) return;
          var next = Math.max(0, Math.min(this.slides.length - 1, index));
          this.lockUntil = Date.now() + 600;
          this.track.scrollTo({ left: next * this.track.clientWidth, behavior: reduceMotion() ? 'auto' : 'smooth' });
          this.setActive(next);
        }

        sync() {
          if (Date.now() < this.lockUntil) return;
          var width = this.track.clientWidth || 1;
          var index = Math.round(this.track.scrollLeft / width);
          if (index !== this.index) this.setActive(index);
        }

        setActive(index) {
          this.index = index;
          this.thumbs.forEach(function (button, n) {
            button.classList.toggle('is-active', n === index);
            button.setAttribute('aria-current', n === index ? 'true' : 'false');
          });
          this.dots.forEach(function (dot, n) {
            dot.classList.toggle('is-active', n === index);
          });
          if (this.count) this.count.textContent = index + 1 + ' / ' + this.slides.length;
        }
      }
    );
  }

  /* ---------- Cards that swipe on mobile ---------- */

  if (!customElements.get('zen-carousel')) {
    customElements.define(
      'zen-carousel',
      class ZenCarousel extends HTMLElement {
        connectedCallback() {
          if (this._zenReady) return;
          this._zenReady = true;

          this.track = this.querySelector('[data-zen-track]');
          this.items = all('[data-zen-item]', this);
          this.dots = all('[data-zen-dot]', this);
          if (!this.track || !this.dots.length) return;

          this.dots.forEach((dot, n) => {
            dot.addEventListener('click', () => {
              var item = this.items[n];
              if (!item) return;
              var padding = parseFloat(window.getComputedStyle(this.track).paddingLeft) || 0;
              this.track.scrollTo({
                left: item.offsetLeft - padding,
                behavior: reduceMotion() ? 'auto' : 'smooth',
              });
            });
          });

          var frame;
          this.track.addEventListener(
            'scroll',
            () => {
              window.cancelAnimationFrame(frame);
              frame = window.requestAnimationFrame(() => this.sync());
            },
            { passive: true }
          );
        }

        sync() {
          var padding = parseFloat(window.getComputedStyle(this.track).paddingLeft) || 0;
          var left = this.track.scrollLeft;
          var best = 0;
          var bestDistance = Infinity;
          this.items.forEach(function (item, n) {
            var distance = Math.abs(item.offsetLeft - padding - left);
            if (distance < bestDistance) {
              bestDistance = distance;
              best = n;
            }
          });
          if (this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2) best = this.items.length - 1;
          this.dots.forEach(function (dot, n) {
            dot.classList.toggle('is-active', n === best);
          });
        }
      }
    );
  }

  /* ---------- Sticky add to cart ---------- */

  if (!customElements.get('zen-sticky-atc')) {
    customElements.define(
      'zen-sticky-atc',
      class ZenStickyAtc extends HTMLElement {
        connectedCallback() {
          if (this._zenReady) return;
          this._zenReady = true;

          var target = document.getElementById(this.dataset.target);
          this.button = this.querySelector('[data-zen-sticky-btn]');
          this.meta = this.querySelector('[data-zen-sticky-meta]');
          if (!target || !('IntersectionObserver' in window)) return;

          if (this.button) {
            this.button.addEventListener('click', function () {
              if (target.disabled) {
                target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
              } else {
                target.click();
              }
            });
          }

          var observer = new IntersectionObserver((entries) => {
            var entry = entries[0];
            var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', show);
            document.body.classList.toggle('zen-sticky-on', show);
            if (show) {
              this.removeAttribute('inert');
              this.setAttribute('aria-hidden', 'false');
            } else {
              this.setAttribute('inert', '');
              this.setAttribute('aria-hidden', 'true');
            }
          });
          observer.observe(target);

          var update = (detail) => {
            if (!detail || detail.sectionId !== this.dataset.section) return;
            if (this.meta) {
              this.meta.textContent = [detail.price, detail.title].filter(Boolean).join(' · ');
            }
            if (this.button) this.button.disabled = !detail.available;
          };

          document.addEventListener('zen:variant-change', function (event) {
            update(event.detail);
          });

          var box = document.querySelector('zen-buy-box[data-section="' + this.dataset.section + '"]');
          if (box && box.state) update(box.state);
        }
      }
    );
  }
})();
